import clsx from 'clsx';
import { IconPlaceholder } from '../Icon';
import {
    UilBrain,
    UilFocusAdd,
    UilHeart,
    UilKid,
    UilSmileBeam,
    UilTornado,
} from '@iconscout/react-unicons';
import { Color } from '../../lib/types.ts';

interface CardProps {
    color?: Color;
    children: React.ReactNode;
}

export default function Card({
    color,
    children,
}: CardProps) {
    const colorVariants = {
        blue: 'bg-base-100',
        green: 'bg-green-500',
        orange: 'bg-orange-100',
        red: 'bg-red-100',
        turquoise: 'bg-turquoise-100',
        purple: 'bg-purple-100',
        rose: 'bg-rose-100',
    };

    return (
        <div
            className={clsx(
                'flex min-h-60 flex-col items-start justify-start border border-gray-200 rounded-3xl p-8',
                color && colorVariants[color]
            )}
        >
            {children}
            {/* <div className="mb-4 flex items-center">
                <div className="mr-3 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-white/10">
                </div>
                <h3 className="tracking-wide text-white">{heading}</h3>
            </div>
            <p className="text-white">{subheading}</p> */}

        </div>
    );
}
